module.exports = __webpack_public_path__ + "fonts/BebasNeue-Bold.785b006.woff2";